import { render, staticRenderFns } from "./NlpWhoIsForIcon4.vue?vue&type=template&id=d7b932a0"
import script from "./NlpWhoIsForIcon4.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsForIcon4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports